<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <b-modal
        id="filter"
        size="xl"
        no-close-on-backdrop
        hide-footer
        title="FILTRAR"
      >
        <div class="row">
          <div class="col-md-12">
            <label>TIPO</label>
            <select v-model="type" class="form-control">
              <option value="EVOLUCAO">FEZ EVOLUÇÃO</option>
              <option value="NAO_EVOLUCAO">NÃO FEZ EVOLUÇÃO</option>
            </select>
          </div>
          <div class="col-xl-3 col-sm-3 col-md-3 col-sm-12 col-12">
            <label>TIPO</label>
            <div
              class="form-check"
              v-if="permission('read', 'evolution_nurse_report')"
            >
              <input
                class="form-check-input"
                type="checkbox"
                v-model="nurse"
                id="nurse"
              />
              <label class="form-check-label" for="nurse">
                ENFERMEIRO(A)
              </label>
            </div>
            <div
              class="form-check"
              v-if="permission('read', 'evolution_doctor_report')"
            >
              <input
                class="form-check-input"
                type="checkbox"
                v-model="doctor"
                id="doctor"
              />
              <label class="form-check-label" for="doctor"> MÉDICO </label>
            </div>
            <div
              class="form-check"
              v-if="permission('read', 'evolution_nutritionist_report')"
            >
              <input
                class="form-check-input"
                type="checkbox"
                v-model="nutritionist"
                id="nutritionist"
              />
              <label class="form-check-label" for="nutritionist">
                NUTRICIONAL
              </label>
            </div>
            <div
              class="form-check"
              v-if="permission('read', 'evolution_physiotherapist_report')"
            >
              <input
                class="form-check-input"
                type="checkbox"
                v-model="physiotherapist"
                id="physiotherapist"
              />
              <label class="form-check-label" for="physiotherapist">
                FISIOTERAPEUTICA
              </label>
            </div>
            <div
              class="form-check"
              v-if="permission('read', 'evolution_psychologist_report')"
            >
              <input
                class="form-check-input"
                type="checkbox"
                v-model="psychologist"
                id="psychologist"
              />
              <label class="form-check-label" for="psychologist">
                PSICOLÓGICA
              </label>
            </div>
            <div
              class="form-check"
              v-if="permission('read', 'evolution_speech_therapist_report')"
            >
              <input
                class="form-check-input"
                type="checkbox"
                v-model="speech_therapist"
                id="speech_therapist"
              />
              <label class="form-check-label" for="speech_therapist">
                FONOAUDIÓLOGO(A)
              </label>
            </div>
            <div
              class="form-check"
              v-if="
                permission('read', 'evolution_occupational_therapist_report')
              "
            >
              <input
                class="form-check-input"
                type="checkbox"
                v-model="occupational_therapist"
                id="occupational_therapist"
              />
              <label class="form-check-label" for="occupational_therapist">
                TERAPEUTA OCUPACIONAL
              </label>
            </div>
            <div
              class="form-check"
              v-if="permission('read', 'evolution_music_therapy_report')"
            >
              <input
                class="form-check-input"
                type="checkbox"
                v-model="music_therapy"
                id="music_therapy"
              />
              <label class="form-check-label" for="music_therapy">
                MUSICOTERAPIA
              </label>
            </div>
            <div
              class="form-check"
              v-if="permission('read', 'evolution_social_worker_report')"
            >
              <input
                class="form-check-input"
                type="checkbox"
                v-model="social_worker"
                id="social_worker"
              />
              <label class="form-check-label" for="social_worker">
                ASSISTENTE SOCIAL
              </label>
            </div>
            <div
              class="form-check"
              v-if="permission('read', 'evolution_physical_educator_report')"
            >
              <input
                class="form-check-input"
                type="checkbox"
                v-model="physical_educator"
                id="physical_educator"
              />
              <label class="form-check-label" for="physical_educator">
                EDUCADOR FÍSICO
              </label>
            </div>
            <div
              class="form-check"
              v-if="
                permission('read', 'evolution_educators_and_pedagogues_report')
              "
            >
              <input
                class="form-check-input"
                type="checkbox"
                v-model="educators_and_pedagogues"
                id="educators_and_pedagogues"
              />
              <label class="form-check-label" for="educators_and_pedagogues">
                EDUCADORES E PEDAGOGOS
              </label>
            </div>
            <div
              class="form-check"
              v-if="permission('read', 'evolution_dentist_report')"
            >
              <input
                class="form-check-input"
                type="checkbox"
                v-model="dentist"
                id="dentist"
              />
              <label class="form-check-label" for="dentist"> DENTISTA </label>
            </div>
          </div>
          <div class="col-xl-4 col-sm-4 col-md-4 col-sm-4 col-4 text-center">
            <label>FILTRAR POR RESIDENTES</label>
            <div class="d-flex align-items-center justify-content-center">
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="resident_active"
                  @change="getResidents"
                  id="resident_active"
                />
                <label class="form-check-label" for="resident_active">
                  ATIVOS
                </label>
              </div>
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="resident_not_active"
                  @change="getResidents"
                  id="resident_not_active"
                />
                <label class="form-check-label" for="resident_not_active">
                  INATIVOS
                </label>
              </div>
            </div>
          </div>
          <div class="col-xl-5 col-sm-5 col-md-5 col-sm-12 col-12">
            <label>Residente</label>
            <select v-model="resident_id" class="form-control">
              <option :value="null">SELECIONE...</option>
              <option
                v-if="
                  rest_home_allow_home_care != 1 &&
                  user_allow_home_care != 1 &&
                  type == 'NAO_EVOLUCAO'
                "
                value="TODOS"
              >
                TODOS OS RESIDENTES
              </option>
              <option
                v-for="resident in residents"
                :key="resident.id"
                :value="resident.id"
              >
                {{ String(resident.name).toUpperCase() }} -
                {{ String(resident.status_type_name).toUpperCase() }}
              </option>
            </select>
          </div>
          <div class="col-xl-3 col-sm-3 col-md-3 col-sm-12 col-12">
            <label>Status</label>
            <select v-model="status" class="form-control">
              <option
                v-for="item in typesFilterByStatus"
                :key="item.id"
                :value="item.id"
              >
                {{ String(item.name).toUpperCase() }}
              </option>
            </select>
          </div>
          <div class="col-xl-3 col-sm-3 col-md-3 col-sm-6 col-12">
            <label>Data inicial</label>
            <input type="date" v-model="dtInit" class="form-control" />
            <small
              >Informe um intervalo de até 31 dias entre a data inicial e
              final.</small
            >
          </div>
          <div class="col-xl-3 col-sm-3 col-md-3 col-sm-6 col-12">
            <label>Data final</label>
            <input type="date" v-model="dtEnd" class="form-control" />
          </div>
          <div class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
            <ErrorsMessages :errors="errors" />
          </div>
          <div
            class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 text-right"
          >
            <v-btn
              :disabled="loading"
              @click="paginate()"
              class="btn-filter"
              type="relief"
              ><i class="fas fa-filter mr-2 text-twenty"></i>
              {{ loading ? "CARREGANDO" : "FILTRAR" }}
            </v-btn>
          </div>
        </div>
      </b-modal>
      <div class="row">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
          <v-btn class="btn-return mb-3" v-on:click="handleToBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
          </v-btn>
        </div>
        <div class="col-xl-7 col-lg-6 col-md-6 col-sm-9 col-12 pt-0">
          <h1 class="title-pages pt-1 check-text-center">
            RELATÓRIO: EVOLUÇÃO MULTIDISCIPLINAR
          </h1>
        </div>
        <div
          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 text-right"
        >
          <v-btn
            @click="$bvModal.show('filter')"
            class="btn-filter mr-2"
            type="relief"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
          </v-btn>
          <v-btn
            :disabled="evolutions.length == 0"
            @click="handleToPrint"
            class="btn-print"
            type="relief"
          >
            <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR
          </v-btn>
        </div>
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0"
          v-if="evolutions.length > 0"
        >
          <h6 class="mb-0 upper-text worksansr check-text-center">
            <p class="m-0 text-center" v-if="type == 'EVOLUCAO'">
              Evoluções realizadas
            </p>
            <p class="m-0 text-center" v-if="type == 'NAO_EVOLUCAO'">
              Evoluções não realizadas
            </p>
            FILTRANDO:
            <span v-if="nurse"><strong>ENFERMEIRO(A)</strong> | </span>
            <span v-if="doctor"><strong>MÉDICO</strong> | </span>
            <span v-if="nutritionist"><strong>NUTRICIONAL</strong> | </span>
            <span v-if="physiotherapist"
              ><strong>FISIOTERAPEUTICA</strong> |
            </span>
            <span v-if="psychologist"><strong>PSICOLÓGICA</strong> | </span>
            <span v-if="occupational_therapist"
              ><strong>TERAPEUTA OCUPACIONAL</strong> |
            </span>
            <span v-if="music_therapy"><strong>MUSICOTERAPIA</strong> | </span>
            <span v-if="speech_therapist"
              ><strong>FONOAUDIÓLOGO(A)</strong> |
            </span>
            <span v-if="social_worker"
              ><strong>ASSISTENTE SOCIAL</strong> |
            </span>
            <span v-if="physical_educator"
              ><strong>EDUCADOR FÍSICO</strong> |
            </span>
            <span v-if="educators_and_pedagogues"
              ><strong>EDUCADORES E PEDAGOGOS</strong> |
            </span>
            <span v-if="dentist"><strong>DENTISTA</strong> | </span>
            <span><strong>RESIDENTE</strong> | </span>
            <span
              ><strong>STATUS: {{ status }}</strong> |
            </span>
            <span
              ><strong>DATA INICIAL: {{ formatDate(dtInit, false) }}</strong> |
            </span>
            <span
              ><strong>DATA FINAL: {{ formatDate(dtEnd, false) }}</strong> |
            </span>
          </h6>
        </div>
      </div>
      <b-overlay :show="loading" opacity="0.99">
        <div class="v-clean p-5 text-center" v-show="evolutions.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <div v-show="evolutions.length > 0">
          <v-data-table
            v-show="return_type == 'EVOLUCAO'"
            dense
            :headers="headers_type_evolution"
            :items="evolutions"
            item-key="id"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.type`]="{ item }">
              {{ handleType(item.type) }}
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <span
                :class="[item.status == 1 ? 'text-success' : 'text-danger']"
              >
                {{ item.status == 1 ? "ATIVO" : "APAGADO" }}
              </span>
            </template>
            <template v-slot:[`item.text`]="{ item }">
              {{
                String(item.text).length > 25
                  ? `${String(item.text).substring(0, 25)}...`
                  : item.text
              }}
            </template>
            <template v-slot:[`item.created_at`]="{ item }">
              {{ formatDate(item.created_at) }}
              <b-modal
                size="md"
                no-close-on-backdrop
                hide-footer
                :id="`evolution-${item.id}`"
                title="EVOLUÇÃO"
              >
                <div class="row">
                  <div class="col-md-12">
                    <textarea
                      disabled
                      class="form-control"
                      v-model="item.text"
                      rows="10"
                    />
                  </div>
                </div>
              </b-modal>
            </template>
          </v-data-table>
          <v-data-table
            v-show="return_type == 'NAO_EVOLUCAO'"
            dense
            :headers="headers_type_not_evolution"
            :items="evolutions"
            item-key="id"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
          >
            <template v-slot:[`item.type`]="{ item }">
              {{ handleType(item.type) }}
            </template>
            <template v-slot:[`item.text`]="{ item }">
              {{ String(item.text) }}
            </template>
          </v-data-table>
        </div>
        <errors-messages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";

import routes from "../../routes";

import { formatDate } from "../../lib/format";

import permission from "../../lib/permission";

import AuthBySessionExpired from "../Components/AuthBySessionExpired";

import ErrorsMessages from "../Components/ErrorsMessages";

import NavBar from "../NavBar";

import { restore, save, userData } from "../../lib/functions";

export default {
  name: "ReportsEvolution",
  components: {
    NavBar,
    ErrorsMessages,
    AuthBySessionExpired,
  },
  data() {
    return {
      type: "EVOLUCAO",
      return_type: "EVOLUCAO",
      resident_active: true,
      resident_not_active: false,
      nurse: false,
      doctor: false,
      nutritionist: false,
      physiotherapist: false,
      psychologist: false,
      speech_therapist: false,
      occupational_therapist: false,
      music_therapy: false,
      social_worker: false,
      physical_educator: false,
      educators_and_pedagogues: false,
      dentist: false,
      dtInit: "",
      dtEnd: "",
      status: "TODOS",
      resident_id: null,
      headers_type_evolution: [
        { text: "TIPO", value: "type" },
        { text: "RESIDENTE", value: "resident_name" },
        { text: "CRIADO POR", value: "user_name" },
        { text: "DATA CADASTRO", value: "created_at" },
        { text: "STATUS", value: "status" },
      ],
      headers_type_not_evolution: [
        { text: "TIPO", value: "type" },
        { text: "RESIDENTE", value: "resident_name" },
      ],
      typesFilterByStatus: [
        { id: "TODOS", name: "Filtrar por todos" },
        { id: "EXCLUIDO", name: "Filtrar apenas excluidas" },
        {
          id: "ATIVO",
          name: "Filtrar apenas ativas",
        },
      ],
      resident_ids: [],
      residents: [],
      evolutions: [],
      errors: [],
      loading: false,

      user_allow_home_care: 0,
      rest_home_allow_home_care: 0,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    permission,
    formatDate,
    saveState() {
      save(this, "ReportsEvolution", [
        "type",
        "return_type",
        "nurse",
        "doctor",
        "nutritionist",
        "physiotherapist",
        "psychologist",
        "speech_therapist",
        "occupational_therapist",
        "music_therapy",
        "social_worker",
        "physical_educator",
        "educators_and_pedagogues",
        "dentist",
        "resident_id",
        "status",
        "dtInit",
        "dtEnd",
      ]);
    },
    handleClickRowTable({ id }) {
      this.$bvModal.show(`evolution-${id}`);
    },
    handleType(type) {
      var show = {
        MEDICO: "MÉDICO",
        ENFERMEIRO: "ENFERMEIRO(A)",
        FISIOTERAPEUTA: "FISIOTERAPEUTA",
        PSICOLOGO: "PSICÓLOGO",
        NUTRICIONISTA: "NUTRICIONAL",
        FONOAUDIOLOGO: "FONOAUDIÓLOGO(A)",
        TERAPEUTA_OCUPACIONAL: "TERAPEUTA OCUPACIONAL",
        MUSICOTERAPIA: "MUSICOTERAPIA",
        ASSISTENTE_SOCIAL: "ASSISTENTE SOCIAL",
        EDUCADOR_FISICO: "EDUCADOR FÍSICO",
        EDUCADORES_E_PEDAGOGOS: "EDUCADORES E PEDAGOGOS",
        DENTISTA: "DENTISTA",
        default: "TIPO NÃO ENCONTRADO!",
      };

      return show[type] || show.default;
    },
    async retrieve() {
      const { user } = userData();

      this.user_allow_home_care = user.allow_home_care;
      this.rest_home_allow_home_care = user.rest_home_allow_home_care;

      restore(this, "ReportsEvolution");
      await this.getResidents();
      if (this.resident_id) {
        await this.paginate();
      }
      let { modal } = this.$router.currentRoute.query;

      if (modal) {
        this.$bvModal.show("filter");
      }
    },
    async getResidents() {
      try {
        let { resident_active, resident_not_active } = this;

        let status = "ATIVO";

        if (resident_active && resident_not_active) {
          status = "ALL";
        } else if (!resident_active && resident_not_active) {
          status = "INATIVO";
        } else if (!resident_active && !resident_not_active) {
          this.errors = [
            {
              id: this.errors.length,
              message: "Informe residentes ativos, inativos ou ambos",
            },
          ];
          this.residents = [];
          return;
        }

        let params = { status };

        const response = await api.get("/rest-home/resident/paginate", {
          params,
        });

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = residents;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async paginate() {
      try {
        const {
          type,
          dtInit,
          dtEnd,
          status,
          resident_id,
          nurse,
          doctor,
          nutritionist,
          physiotherapist,
          psychologist,
          speech_therapist,
          occupational_therapist,
          music_therapy,
          social_worker,
          physical_educator,
          educators_and_pedagogues,
          dentist,
          resident_active,
          resident_not_active,
        } = this;

        if (type == "NAO_EVOLUCAO") {
          let countTypes = 0;
          if (nurse) {
            countTypes++;
          }
          if (doctor) {
            countTypes++;
          }
          if (nutritionist) {
            countTypes++;
          }
          if (physiotherapist) {
            countTypes++;
          }
          if (psychologist) {
            countTypes++;
          }
          if (speech_therapist) {
            countTypes++;
          }
          if (occupational_therapist) {
            countTypes++;
          }
          if (music_therapy) {
            countTypes++;
          }
          if (social_worker) {
            countTypes++;
          }
          if (physical_educator) {
            countTypes++;
          }
          if (educators_and_pedagogues) {
            countTypes++;
          }
          if (dentist) {
            countTypes++;
          }
          if (countTypes > 1 && resident_id == "TODOS") {
            this.errors = [
              "Informe apenas um tipo de evolução para a filtragem de (NÃO FEZ EVOLUÇÃO) e (TODOS OS RESIDENTES)",
            ];
            return;
          }
        }

        let params = {
          type,
          dtInit,
          dtEnd,
          status,
          resident_id,
          nurse,
          doctor,
          nutritionist,
          physiotherapist,
          psychologist,
          speech_therapist,
          occupational_therapist,
          music_therapy,
          social_worker,
          physical_educator,
          educators_and_pedagogues,
          dentist,
          resident_active,
          resident_not_active,
        };

        this.loading = true;

        const response = await api.get("/rest-home/report/evolution/filter", {
          params,
        });

        const { evolutions, return_type, error, errors } = response.data;

        this.return_type = return_type;

        if (error) {
          this.evolutions = [];
          this.errors = errors;
        } else {
          this.errors = [];
          this.evolutions = evolutions;
          let resident_ids = [];
          for (let ev of evolutions) {
            resident_ids.push(ev.resident_id);
          }
          this.resident_ids = resident_ids;
          this.$bvModal.hide("filter");
        }

        this.saveState();
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleToPrint() {
      const {
        type,
        return_type,
        evolutions,
        resident_ids,
        nurse,
        doctor,
        nutritionist,
        physiotherapist,
        psychologist,
        speech_therapist,
        occupational_therapist,
        music_therapy,
        social_worker,
        physical_educator,
        educators_and_pedagogues,
        dentist,
        dtInit,
        dtEnd,
      } = this;

      let types = [];

      if (nurse) {
        types.push("ENFERMEIRO");
      }

      if (doctor) {
        types.push("MEDICO");
      }

      if (nutritionist) {
        types.push("NUTRICIONISTA");
      }

      if (physiotherapist) {
        types.push("FISIOTERAPEUTA");
      }

      if (psychologist) {
        types.push("PSICOLOGO");
      }

      if (speech_therapist) {
        types.push("FONOAUDIOLOGO");
      }

      if (occupational_therapist) {
        types.push("TERAPEUTA_OCUPACIONAL");
      }

      if (music_therapy) {
        types.push("MUSICOTERAPIA");
      }

      if (social_worker) {
        types.push("ASSISTENTE_SOCIAL");
      }

      if (physical_educator) {
        types.push("EDUCADOR_FISICO");
      }

      if (educators_and_pedagogues) {
        types.push("EDUCADORES_E_PEDAGOGOS");
      }

      if (dentist) {
        types.push("DENTISTA");
      }

      let ids = [];
      if (return_type == "EVOLUCAO") {
        for (const item of evolutions) {
          ids.push(item.id);
        }
      }

      let resident_ids_added = [];
      for (let res of resident_ids) {
        if (!resident_ids_added.includes(res)) {
          resident_ids_added.push(res);
        }
      }

      let route = this.$router.resolve({
        name: "report_evolution",
        params: {
          type,
          types: types.join(","),
          resident_ids: resident_ids_added.join(","),
          ids: return_type == "EVOLUCAO" ? ids.join(",") : false,
          dtInit,
          dtEnd,
        },
      });

      window.open(route.href, "_blank");
    },
    handleToBack: () => routes.go(-1),
  },
};
</script>
